export const FORGOTTEN_PASSWORD_TEXT = {
  'forgotten_password.page_title': {
    'en-GB': 'Forgotten Password | Moonpig',
    'nl-NL': 'Wachtwoord vergeten | Greetz',
  },
  'forgotten_password.valid_email_error': {
    'en-GB': 'Please enter a valid email address',
    'nl-NL': 'Voer een geldig e-mailadres in',
  },
  'forgotten_password.heading': {
    'en-GB': 'Forgotten your password?',
    'nl-NL': 'Je wachtwoord vergeten?',
  },
  'forgotten_password.invalid_token_error': {
    'en-GB': 'Oops!',
    'nl-NL': 'Oeps!',
  },
  'forgotten_password.instructions': {
    'en-GB':
      'Simply enter your email address below and we will email you a link to reset your password',
    'nl-NL':
      'Voer hieronder je e-mailadres in, dan mailen we je een link om je wachtwoord opnieuw in te stellen',
  },
  'forgotten_password.link_expired_error_title': {
    'en-GB': 'The link has expired',
    'nl-NL': 'De link is verlopen',
  },
  'forgotten_password.link_expired_error_message': {
    'en-GB': 'Please re-enter your email to reset your password',
    'nl-NL':
      'Voer je e-mailadres opnieuw in om je wachtwoord opnieuw in te stellen',
  },
  'forgotten_password.email_input_label': {
    'en-GB': 'Email',
    'nl-NL': 'E-mail',
  },
  'forgotten_password.email_input_placeholder': {
    'en-GB': 'e.g jenny.hubble@moonpig.com',
    'nl-NL': 'bv. jan.debont@greetz.com',
  },
  'forgotten_password.send': {
    'en-GB': 'Send email',
    'nl-NL': 'Stuur e-mail',
  },
  'forgotten_password.cancel': {
    'en-GB': 'Cancel',
    'nl-NL': 'Annuleren',
  },
  'forgotten_password.success': {
    'en-GB': (
      email: string,
    ) => `An email with instructions on how to reset your password has been
    sent to ${email}`,
    'nl-NL': /* istanbul ignore next */ (email: string) =>
      `We hebben een e-mail verstuurd naar ${email} met instructies over het opnieuw instellen van je wachtwoord`,
  },
  'forgotten_password.failure': {
    'en-GB': 'Oops something went wrong, please try again',
    'nl-NL': 'Oeps, er ging iets mis, probeer het opnieuw',
  },
  'forgotten_password.email_sent': {
    'en-GB': 'Email Sent',
    'nl-NL': 'E-mail verzonden',
  },
}
